export const defaultStyles = {
  section: {
    textAlign: "center" as const,
    fontSize: "12px",
  },
  image: {
    height: "20px",
    width: "32px",
  },
  hr: {
    margin: "16px 0",
  },
  logoRow: {
    width: "100%",
    margin: "16px 0",
  },
  urlRow: {
    width: "100%",
  },
  addressRow: {
    margin: "8px 0",
  },
  preferencesRow: {
    width: "100%",
    fontSize: "12px",
    margin: "8px 0",
  },
  link: {
    color: "#545861",
    textDecoration: "underline",
    margin: "0 4px",
  },
  communityName: {
    fontSize: "14px",
    fontWeight: "500",
  },
};
